import React, { Component } from "react";
import { Divider, Button, Select } from "antd";
import {
  getRedirectQueryParams,
  selectFilterFunction,
} from "../../Constants/Utilities";
import {
  AppStorageKeys,
  DefaultServiceProvider,
  DeviceManagePaths,
} from "../../Constants/Constants";
import { PlusCircleOutlined } from "@ant-design/icons";
import { DeviceActions } from "../../Constants/Constants";
import SessionStorage from "../../Constants/SessionStorage";
import { BreadCrumbs } from "../Common/BreadCrumbs";

const ENV_VARS_FE = SessionStorage.get(AppStorageKeys.envVars);

export default class ListOrders extends Component {
  constructor(props) {
    super(props);
    const { protocol, hostname } = window.location;
    this.deviceManageUrl =
      protocol + "//" + hostname + ":" + ENV_VARS_FE.DEVICE_MANAGE_PORT;
  }

  render() {
    const {
      providerData,
      providerDataLoading,
      selectedProvider,
      onProviderSelect,
      selectedProviderName,
      onActionClick,
      parentBread,
    } = this.props;

    const redirectUrl = getRedirectQueryParams({
      path: DeviceManagePaths.purOrder,
      part: selectedProviderName,
      prov: selectedProvider,
    });

    return (
      <div className="entity-list-container">
        <div className="page-header-container">
          <BreadCrumbs headers={parentBread} />
        </div>
        <Divider className="divider" />
        <div className="search-add-container">
          <div className="search-container">
            <span className="search-label">Service Provider:</span>
            <Select
              showSearch
              allowClear
              value={selectedProvider}
              loading={providerDataLoading}
              disabled={providerDataLoading}
              onChange={onProviderSelect}
              filterOption={selectFilterFunction}
              style={{ minWidth: "200px", maxWidth: "250px" }}
              placeholder={
                providerDataLoading
                  ? "Loading Service Providers..."
                  : "Select Service Provider"
              }
            >
              {providerData?.map((item) => (
                <Select.Option key={item.providerId} title={item.providerName}>
                  {item.providerName}
                </Select.Option>
              ))}
            </Select>
          </div>
          <div className="add-container">
            {!this.props.deviceModelRecord &&
              selectedProviderName === DefaultServiceProvider && (
                <Button
                  type="primary"
                  icon={<PlusCircleOutlined />}
                  onClick={onActionClick(DeviceActions.bulkAdd, null)}
                >
                  Import Orders
                </Button>
              )}
          </div>
        </div>
        {!selectedProvider ? (
          <div className="no-entity-warning">
            <div className="warning-label">
              Select any Service Provider to view Orders
            </div>
          </div>
        ) : (
          <iframe
            className="new-frame"
            title="Order Management"
            src={this.deviceManageUrl + "/login?" + redirectUrl}
          />
        )}
      </div>
    );
  }
}
